module.exports = __webpack_public_path__ + "img/Salad Icon - white.e369cf7f.svg";